<div class="modal-header">
    <h4 class="modal-title">Economic settings</h4>
    <button (click)="onDismiss()" [disabled]="saving()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    @if (officeSettings$ | async; as officeSettings) {
        <form (ngSubmit)="saveToken()">
            <div class="mb-3">
                <label for="economicAgreementGrantToken">{{ officeSettings.hasEconomicAgreementGrantToken ? 'Erstat Agreement grant token' : 'Agreement grant token' }}</label>
                <input [(ngModel)]="token"
                       [disabled]="saving()"
                       [placeholder]="officeSettings.hasEconomicAgreementGrantToken ? '••••••••' : 'Indsæt dit token fra e-conomic'"
                       name="economicAgreementGrantToken"
                       type="password"
                       autocomplete="new-password"
                       spellcheck="false"
                       class="form-control"
                       id="economicAgreementGrantToken">
            </div>
            @if (saving()) {
                <p class="mb-3" role="status">Gemmer ændringen…</p>
            }
            @if (error()) {
                <p class="text-danger mb-3" role="alert">{{ error() }}</p>
            }
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <a href="https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=I38cjwn9Pty2AXfDpYqpVmIXKB6UbKSDJiiouIrhZpQ"
                   target="_blank"
                   rel="noopener noreferrer"
                   aria-label="Giv adgang til e-conomic (åbner i en ny fane)"
                   title="Åbner i en ny fane"
                   class="btn btn-outline-primary">Giv adgang til e-conomic <span aria-hidden="true">↗</span></a>
                <div class="d-flex gap-2 ms-auto">
                    @if (officeSettings.hasEconomicAgreementGrantToken) {
                        <button type="button" class="btn btn-outline-danger" [disabled]="saving()" (click)="removeToken()">Fjern token</button>
                    }
                    <button type="submit" class="btn btn-primary" [disabled]="saving() || !token.trim()">Gem token</button>
                </div>
            </div>
        </form>
    }
</div>
